import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, Search, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { islandUrl } from "@/lib/translations";

/** Echte 404-Seite: noindex + Statuscode fürs Pre-Rendering, Titel, hilfreiche Links (statt stiller Weiterleitung auf die Startseite). */
export default function NotFound({ island }) {
  const { lang, t } = useLang();
  const N = t.notFound;
  useEffect(() => {
    const prev = document.title;
    document.title = N.title;
    const tags = [["robots", "noindex, nofollow"], ["prerender-status-code", "404"]].map(([name, content]) => { const m = document.createElement("meta"); m.name = name; m.content = content; document.head.appendChild(m); return m; });
    document.head.querySelector('link[rel="canonical"]')?.remove();
    return () => { tags.forEach((m) => m.remove()); document.title = prev; };
  }, [N.title, lang]);
  const btn = "inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors";
  return (
    <section className="max-w-3xl mx-auto px-6 lg:px-10 py-24 md:py-32" data-testid="not-found-page">
      <div className="text-xs uppercase tracking-[0.3em] text-brand font-semibold mb-4">404</div>
      <h1 className="font-serif text-4xl sm:text-5xl text-stone-900 leading-tight" data-testid="not-found-h1">{N.h1}</h1>
      <p className="text-base md:text-lg text-stone-600 mt-6">{N.text}</p>
      <div className="flex flex-wrap gap-3 mt-8">
        <Link to="/" className={`${btn} bg-brand hover:bg-brand-hover text-white`} data-testid="not-found-home"><Home className="w-4 h-4" />{N.home}</Link>
        <Link to="/properties" className={`${btn} border border-stone-300 text-stone-800 hover:border-brand hover:text-brand`} data-testid="not-found-properties"><Search className="w-4 h-4" />{N.properties}</Link>
        {island && t.islands[island] && <Link to={islandUrl(island)} className={`${btn} border border-stone-300 text-stone-800 hover:border-brand hover:text-brand`} data-testid="not-found-island"><MapPin className="w-4 h-4" />{N.island.replace("{n}", t.islands[island])}</Link>}
      </div>
    </section>
  );
}
